import { render, staticRenderFns } from "./questionMore.vue?vue&type=template&id=fe5ac40e&scoped=true&"
import script from "./questionMore.vue?vue&type=script&lang=js&"
export * from "./questionMore.vue?vue&type=script&lang=js&"
import style0 from "./questionMore.vue?vue&type=style&index=0&id=fe5ac40e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5ac40e",
  null
  
)

export default component.exports